/* eslint-disable prettier/prettier */
import { message } from 'antd';
import TOS from '@volcengine/tos-sdk';
import { STSRequest, STSState } from '@/store/slices/sts';
import * as Apis from '@/apis/login';

interface IUploadFile {
  key: string;
  file: File;
  onProgress?: (uploadPercent: number) => void;
}

export async function getTosConfig(stsRequestParam: STSRequest) {
  const stsRes = await Apis.getSTS({
    file_name: stsRequestParam.file_name || '',
    login_token: stsRequestParam.login_token || '',
  });

  const tosConfig = {
    account_id: stsRes.response?.account_id,
    region: stsRes.response?.region,
    endpoint: stsRes.response?.endpoint,
    bucket: stsRes.response?.bucket,
    ak: stsRes.response?.ak,
    sk: stsRes.response?.sk,
    token: stsRes.response?.token,
    current_time: stsRes.response?.current_time,
    expired_time: stsRes.response?.expired_time,
    key: stsRes.response?.key,
  };

  return tosConfig;
}

async function uploadFile(params: IUploadFile, tosConfig: STSState) {
  const format = params.file.name.split('.').pop();

  if (
    params.file.size > 100 * 1000 * 1000 &&
    ['jpg', 'jpeg', 'png', 'bmp'].includes(format || '')
  ) {
    throw new Error('图片大小不可超过100MB');
  }
  if (params.file.size > 200 * 1000 * 1000) {
    throw new Error('文件大小不可超过200MB');
  }

  const initializeTOSConfig = {
    accessKeyId: tosConfig.ak || '',
    accessKeySecret: tosConfig.sk || '',
    region: tosConfig.region || '',
    endpoint: tosConfig.endpoint || '',
    bucket: tosConfig.bucket || '',
    requestTimeout: 30000,
    stsToken: tosConfig.token || '',
  };

  const client = new TOS(initializeTOSConfig);

  try {
    await client.uploadFile({
      key: params.key,
      file: params.file,
      partSize: 5 * 1024 * 1024,
      progress: (percent) => {
        params.onProgress && params.onProgress(percent * 100);
      },
    });

    const url = client.getPreSignedUrl({ key: params.key, expires: 7 * 24 * 3600 });
    return url;
  } catch (error: any) {
    console.error('tos err', error);
    message.error(`tos error: ${error.toString()}`);
  }
}

export function validateUrl(url: string) {
  // eslint-disable-next-line
  return new RegExp(
    '^((?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?)?$',
    'i'
  ).test(url);
}

export default uploadFile ;
